import React from "react";
import { connect } from "react-redux";
import {
  setActiveStepOrderCard,
  setCardsDataThunk,
  setDefaultValues,
} from "../../redux/card-reducer";
import {
  setOpenCheckOrder,
  setOpenMainCardModal,
} from "../../redux/data-reducer";
import MainCardModal from "../modal/mainCardModal/MainCardModal";
// import { setActiveOrderCard } from '../../redux/card-reducer'
import CardsPage from "./CardsPage";

import qs from "qs";
import { transValidNumber } from "../../common/tools";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { RoutesNames } from "../../common/routes";
import { clearCardCheckData } from "../../redux/applicant-reducer";

class CardsPageContainer extends React.Component {
  componentDidMount() {
    if (this.props.history.location.pathname === RoutesNames.CARDS) {
      this.props.clearApplicant();
    }
    if (!this.props.cardTypeData || this.props.cardTypeData.length < 1) {
      this.props.setCardsDataThunk();
    }
    this.props.setActiveStepOrderCard(1);
    var dv = {};

    Object.keys(this.props.defaultValues).map((k) => {
      dv[k] =
        qs.parse(window.location.search, { ignoreQueryPrefix: true })[k] ||
        this.props.defaultValues[k];
    });
    this.props.setDefaultValues({
      ...dv,
      phone: transValidNumber(dv.phone),
    });
  }

  render() {
    const handleOpenCheckOrder = () => {
      this.props.setOpenCheckOrder(true);
    };
    const handleCloseCheckOrder = () => {
      this.props.setOpenCheckOrder(false);
    };
    return (
      <div>
        <MainCardModal
          setOpen={this.props.setOpenMainCardModal}
          open={this.props.openMainCardModal}
          handleCloseCheckOrder={handleCloseCheckOrder}
          handleOpenCheckOrder={handleOpenCheckOrder}
        />
        <CardsPage {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  openMainCardModal: state.data.openMainCardModal,
  openCheckOrder: state.data.openCheckOrder,
  defaultValues: state.cardPage.defaultValues,
  cardTypeData: state.cardPage.cardTypeData,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    setOpenMainCardModal,
    setActiveStepOrderCard,
    setOpenCheckOrder,
    setDefaultValues,
    setCardsDataThunk,
    clearApplicant: clearCardCheckData,
  }),
)(CardsPageContainer);
